module.exports = __webpack_public_path__ + "static/Nihal_Desai-3dd6cffb3a9a523f813989b6a937c95f.jpeg";